import * as React from "react";
import { reducer, initialState } from '../reducer'

const PickerContext = React.createContext(null);

export const PickerContextProvider = ({initialState: contextState, children}) => {
    // console.log(contextState)
    const [state, dispatch] = React.useReducer(reducer, {...initialState, ...contextState});

    return <PickerContext.Provider value={{state, dispatch}}>{children}</PickerContext.Provider>
};

export const usePickerContext = () => {

    return React.useContext(PickerContext);
};